import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/Auth/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const allowed = auth.isWithPrivilege();

  const current_role = auth.getCurrentRole();

  if (route.data['roles'].includes(current_role) || allowed) {
    return true;
  }

  const root = auth.getRoleIndex();
  return inject(Router).createUrlTree([root]);
};
